import Logger from "js-logger";

export default function dataUtils() {
  function copyInto(src: any, dest: any) {
    if (null == src || "object" != typeof src) return;

    Logger.trace("src", src, "dest", dest);

    // Behandelt Array
    if (src instanceof Array) {
      for (let i = 0, len = src.length; i < len; i++) {
        if (dest) {
          copyInto(src[i], dest[i]);
        }
      }
    }

    // Behandelt Object
    else if (src instanceof Object) {
      for (const attr in src) {
        // eslint-disable-next-line no-prototype-builtins
        if (src.hasOwnProperty(attr)) {
          Logger.trace("src[" + attr + "]", src[attr], "dest[" + attr + "]", dest[attr]);

          if (isPrimitive(src[attr])) {
            dest[attr] = src[attr];
          } else {
            copyInto(src[attr], dest[attr]);
          }
        }
      }
    }
  }

  function isPrimitive(test: any) {
    return test !== Object(test);
  }

  const isEmpty = (test: any) => {
    return !test && test !== null && test !== "";
  };

  const gt = (val1: number | undefined | null, val2: number) => {
    return val1 !== undefined && val1 !== null && val1 > val2;
  };

  const lt = (val1: number | undefined | null, val2: number) => {
    return val1 !== undefined && val1 !== null && val1 < val2;
  };

  const eq = (val1: number | undefined | null, val2: number) => {
    return val1 !== undefined && val1 !== null && val1 === val2;
  };

  const gte = (val1: number | undefined | null, val2: number) => {
    return val1 !== undefined && val1 !== null && val1 >= val2;
  };

  const lte = (val1: number | undefined | null, val2: number) => {
    return val1 !== undefined && val1 !== null && val1 <= val2;
  };

  const sub = (val1: number | undefined | null, val2: number | undefined | null) => {
    return val1 !== undefined && val1 !== null && val2 !== undefined && val2 !== null ? val1 - val2 : undefined;
  };

  const add = (val1: number | undefined | null, val2: number | undefined | null) => {
    return val1 !== undefined && val1 !== null && val2 !== undefined && val2 !== null ? val1 + val2 : undefined;
  };

  return {
    copyInto,
    isEmpty,
    gt,
    lt,
    eq,
    gte,
    lte,
    sub,
    add,
  };
}
